import { render, staticRenderFns } from "./address-detail.vue?vue&type=template&id=6c996b76&scoped=true&"
import script from "./address-detail.vue?vue&type=script&lang=js&"
export * from "./address-detail.vue?vue&type=script&lang=js&"
import style0 from "./address-detail.vue?vue&type=style&index=0&id=6c996b76&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c996b76",
  null
  
)

export default component.exports